import { useContext } from 'react';

import { Context, Types } from '../../store';
import { useService } from '../../store/useService';
import { SEARCH_REFERENCES } from '../StartReceiving/StartReceivingService';
import { GET_PERMISSIONS } from './GetPermissionsService';
import { WidgetType } from "../../widgets/widgetCommon/widgetConstants";

export const useGetPermissions = () => {
  const { dispatch, state } = useContext(Context);
  const { useLazyQuery } = useService();
  const isInventoryAdjustmentWidget = state.widgetType === WidgetType.INVENTORY_ADJUSTMENT;

  const [getPermissionsForIAArgo, { loading: iaLoading }] = useLazyQuery(GET_PERMISSIONS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      /* istanbul ignore next */
      dispatch({
        type: Types.updatePermissionsForIA,
        payload: {
          hasPermissionsToAccessIA: data?.getPermissions?.hasPermissions,
        },
      });
    },
    onError: (e) => {
      dispatch({
        type: Types.updatePermissionsForIA,
        payload: {
          hasPermissionsToAccessIA: false,
        },
      });
    },
  });

  const [getPermissionsForReceiveSearch, { loading: receiveLoading }] = useLazyQuery(SEARCH_REFERENCES, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      /* istanbul ignore next */
      dispatch({
        type: Types.updatePermissionsForReceive,
        payload: {
          hasPermissionsToAccessReceive: true,
        },
      });

      if (isInventoryAdjustmentWidget) {
        dispatch({
          type: Types.updatePermissionsForIA,
          payload: {
            hasPermissionsToAccessIA: true,
          },
        });
      }
    },

    onError: (e) => {
      dispatch({
        type: Types.updatePermissionsForReceive,
        payload: {
          hasPermissionsToAccessReceive: false,
        },
      });

      if (isInventoryAdjustmentWidget) {
        dispatch({
          type: Types.updatePermissionsForIA,
          payload: {
            hasPermissionsToAccessIA: false,
          },
        });
      }
    },
  });

  const getPermissionsForReceive = () => {
    getPermissionsForReceiveSearch({
      variables: {
        referenceIdList: [
          {
            type: 'NON_SPECIFIC',
            value: 'no_receive_permissions',
          },
        ],
            locationIdList: [],
      },
    });
  };

  const getPermissionsForIA = () => {
    // If Argo is being used get Inventory Adjustment permissions
    //    Boost will use getPermissionsForReceive
    !isInventoryAdjustmentWidget && getPermissionsForIAArgo({})
  };

  return {
    getPermissionsForIA: getPermissionsForIA,
    iaLoading: isInventoryAdjustmentWidget ? receiveLoading : iaLoading,
    getPermissionsForReceive,
    receiveLoading,
  };
};
export default useGetPermissions;
